import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const CompetitionRoutes: BaseRoute[] = [
  {
    path: '*',
    title: 'Competitions',
    name: 'rewards.competitions.tabs.competitions',
    feature: Feature.Competitions,
    component: React.lazy(() => import('./tabs/competitions')),
    hideFromMainMenu: true,
    icon: 'icon-rewards-benefit-competitions',
    isActive: true,
  },
  {
    path: 'winners-circle',
    title: 'Winners Circle',
    name: 'rewards.competitions.tabs.winnersCircle',
    feature: Feature.Competitions,
    component: React.lazy(() => import('./tabs/winners-circle/winners-circle')),
    hideFromMainMenu: true,
    icon: 'icon-rewards-benefit-challenges',
  },
];